import React from 'react';
import { Button, Modal, Collapse, Tag, Descriptions, Alert } from 'antd';
import { useError } from '../Hooks/Error.hook';

const { Panel } = Collapse;

const ModalError = () => {
  const [{ error, ...errorBody }, , clear] = useError();
  const _renderErrors = () => {
    if (errorBody.data.errors) {
      return Object.keys(errorBody.data.errors).map((key) => {
        let sText = errorBody.data.errors[key],
          sKey = key;

        // Obtenemos el posible nombre del campo
        if (sText.indexOf('"') > -1) {
          sKey = sText.substring(sText.indexOf('"') + 1, sText.lastIndexOf('"'));
        }

        return <Panel header={sKey}>{errorBody.data.errors[key]}</Panel>;
      });
    }

    return <></>;
  };
  return (
    <Modal
      title="Hubo un error inesperado"
      visible={error}
      onCancel={clear}
      footer={[
        <Button type="primary" onClick={clear} key="1">
          Cerrar
        </Button>,
      ]}
    >
      <div className="ErrorMessage">
        <Descriptions size="small">
          <Descriptions.Item label="Nombre del error" span={2}>
            {errorBody.data.name}
          </Descriptions.Item>
          <Descriptions.Item label="Estatus" span={1}>
            <Tag color="red">{errorBody.data.code}</Tag>
          </Descriptions.Item>
        </Descriptions>
        <Descriptions>
          <Descriptions.Item label=" Mensaje de error">
            {errorBody.data.message}
          </Descriptions.Item>
        </Descriptions>
        <Collapse>{_renderErrors()}</Collapse>
        <Alert
          style={{ marginTop: 10 }}
          message="NOTA"
          description="Si el error persiste contacte al administrador"
          type="warning"
          showIcon
        />
      </div>
    </Modal>
  );
};
export default ModalError;
